import React, { useEffect, useState } from 'react'
import Button from "@mui/material/Button";
import Axios from "axios";
import { API_URL_UMS } from '../../../Constant';

const UpdateUserStatus = (props) => {
  const { userID } = props;
  const [assignRole, setAssignRole] = useState({
    user: "",
    status: "",
    referenceNumber: ""
  })
  const [userList, setUserList] = useState([])
  const [success, setSucces] = useState("")
  const [statusError, setStatusError] = useState("")
  const [userError, setUserError] = useState("")

  const handleFormControl = (e) => {
    setStatusError("")
    setUserError("")
    setAssignRole({ ...assignRole, [e.target.name]: e.target.value })
  }

  const onUpdate = (e) => {
    e.preventDefault()
    if (assignRole.status === "" && assignRole.user === "") {
      setStatusError("Required")
      setUserError("Required")
      return 0;
    }
    if (assignRole.user === "" || assignRole.user === "Select user") {
      setUserError("Required")
      return 0;
    }

    if (assignRole.status === "" || assignRole.status === "Select Status") {
      setStatusError("Required")
      return 0;
    }

    let postObject = {
      "referenceNumber": assignRole.referenceNumber,
      "loggedUserId": userID,
      "userId": assignRole.user,
      "status": assignRole.status
    }

    Axios({
      method: "PUT",
      url: `${API_URL_UMS}audit/user-status`,
      data: postObject,
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
      },
    })
      .then(async (response) => {
        console.log("responseeeee : ", response)
        setSucces(response.data)
        setTimeout(() => {
          setSucces("")
        }, 5000)
        // Call Gain APi to fetch and refresh user
        // ###################################
        const requestOptions = {
          headers: {
            "Content-Type": "application/json",
            "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
          },
        };
        Axios.get(
          `${API_URL_UMS}audit/allUsers`,
          requestOptions
        )
          .then((response) => {
            setUserList(response.data)
          })
          .catch((error) => {
          });
      })
      .catch((err) => {
      });


  }

  useEffect(() => {
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
      },
    };
    Axios.get(
      `${API_URL_UMS}audit/allUsers`,
      requestOptions
    )
      .then((response) => {
        setUserList(response.data)
      })
      .catch((error) => {
      });
  }, [])

  return (
    <div className='row mt-3'>
      <div className='col-md-6 mx-auto card p-3'>
        <form className='formField'>
          <div className="form-group row">
            <label htmlFor="validationScreen" className="col-sm-4 col-form-label">User<span className='text-danger'>*</span> :</label>
            <div className="col-sm-6">
              <select onChange={handleFormControl} name="user" class={`form-select ${userError && "formValidation"}`} aria-label="Default select example">
                <option selected>Select user</option>
                {userList && userList.length > 0 && userList.map((item) => <option value={item.userId}>{item.userId}</option>)}
              </select>
              <small id="validationSubScreen" class="form-text text-right text-danger">{userError}</small>
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="validationSubScreen" className="col-sm-4 col-form-label">Status<span className='text-danger'>*</span> :</label>
            <div className="col-sm-6">
              <select onChange={handleFormControl} name="status" class={`form-select ${statusError && "formValidation"}`} aria-label="Default select example">
                <option selected>Select Status</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
              <small id="validationSubScreen" class="form-text text-right text-danger">{statusError}</small>
            </div>
          </div>

          <div className="form-group row">
            <label htmlFor="referenceNumber" className="col-sm-4 col-form-label text-nowrap">Reference Number</label>
            <div className="col-sm-6">
              <input type="text" name="referenceNumber" onChange={handleFormControl} className="form-control" id="referenceNumber" value={assignRole.referenceNumber} />
            </div>
          </div>
          <div className="row">
            <div className="col-12 text-success text-center">
              <span >{success && success}</span>
            </div>
          </div>
          <div className="row">
            <div className="col-12 text-center">
              <Button
                variant="contained"
                className="btncolor"
                size="small"
                type="submit"
                sx={{ m: 1 }}
                onClick={onUpdate}
              >
                Submit
              </Button>
            </div>
          </div>

        </form>
      </div>
    </div>
  )
}

export default UpdateUserStatus